import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  markKnowmixKnowmeetAsDone,
  managedMeetsList,
} from "../../../../../library/store/actions/creators/uknowCreators"
import { addMonths, format, subMonths } from "date-fns"
import Table, {
  recordsPerPageOptions,
} from "../../../../../components/v2/table/table"
import { TablePagination, Tooltip } from "@material-ui/core"
import styled from "@emotion/styled"
import { colors } from "../../../../../library/constants/styles/colors"
import { getTeacherKnowmapKnowmeets } from "../../../../../library/store/actions/creators/knowmapCreators"
import KnowmeetModalsProvider, {
  useKnowmeetModals,
} from "../../../../../hooks/entities/useKnowmeetModals"
import * as qs from "query-string"
import {
  Route,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from "react-router-dom"
import MeetModalsProvider, {
  useMeetModals,
} from "../../../../../hooks/entities/useMeetsModals"
import { key } from "../../../../../library/utils/generateKey"
import EditOutlined from "@material-ui/icons/EditOutlined"
import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined"
import {
  KNOWMAP_INCOMING_KNOWMEET,
  KNOWMAP_INCOMING_MEET,
  KNOWMAP_MEETS,
  KNOWMAP_UKNOW_KNOWMIX,
} from "../../../../../library/constants/routes"
import UknowDialog from "../../../knowmix/knowmixSingle/knowmixSettings/knowmixSettingsKnowmeets/uknowDialog/uknowDialog"
import MeetDialog from "./MeetDialog"
import { useAlert } from "../../../../../hooks/useAlert"
import { SearchOutlined } from "@material-ui/icons"
import composeQuery from "../../../../../library/utils/composeQuery"
import Loader from "../../../../../components/ui/loader"
import Stub from "../../../../../components/stub"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"

const columns = [
  { id: 1, label: "Name" },
  { id: 2, label: "Target/Set Date" },
  { id: 3, label: "Creator" },
  { id: 4, label: "Location" },
  { id: 5, label: "Instructions" },
]

const Container = styled.div`
  padding: 15px 10px;
  box-shadow: 0 0 2px 0 ${colors.black12};
  background-color: ${colors.white};
  border-radius: 2px;
`

const MeetsTable = ({ getRecords }) => {
  const history = useHistory()
  const location = useLocation()
  const { path } = useRouteMatch()
  const params = useParams()

  const { successAlert, errorAlert } = useAlert()

  const [dates, setDates] = React.useState({
    date_from: subMonths(new Date(), 4),
    date_to: addMonths(new Date(), 4),
  })
  const dispatch = useDispatch()
  const { managedMeets } = useSelector(({ uknow }) => uknow)

  const [name, setName] = useState("")
  const [page, setPage] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(recordsPerPageOptions[0])

  const [dataReceived, setDataReceived] = useState(false)
  const [changingPage, setChangingPage] = useState(false)

  const fetchData = async (offset = 0, shouldPageChange = false) => {
    const { q } = qs.parse(location.search)
    if (shouldPageChange) setChangingPage(true)

    await getRecords({
      name: q || undefined,
      offset,
      limit: recordsPerPage,
    })

    setDataReceived(true)
    if (shouldPageChange) setChangingPage(false)
  }

  React.useEffect(() => {
    const { q } = qs.parse(location.search)

    if (typeof q === "string") {
      setName(q)
    }

    fetchData()
  }, [])

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const [meetModalOpen, setMeetModalOpen] = useState(false)
  const [activeMeet, setActiveMeet] = useState(null)

  const { onFormOpen, onInfoOpen, onDeletionOpen } = useMeetModals()

  const initCompletionConfirmation = (id) => {
    setIsConfirmationOpen(true)
    setActiveMeet(id)
  }

  const closeCompletionConfirmation = () => {
    setIsConfirmationOpen(false)
    setActiveMeet(null)
  }

  const onMarkAsDone = async () => {
    try {
      await dispatch(markKnowmixKnowmeetAsDone({ id: activeMeet }))
      successAlert("Completion confirmed")
      setIsConfirmationOpen(false)
      setActiveMeet(null)

      if (path === KNOWMAP_INCOMING_KNOWMEET) {
        history.replace(KNOWMAP_UKNOW_KNOWMIX)
      }
    } catch (e) {
      errorAlert(e)
    }
  }

  const _composeQuery = () => {
    composeQuery({
      fields: {
        q: name || undefined,
      },
      history,
      path,
    })
  }

  const onSearch = (event) => {
    event.preventDefault()

    _composeQuery()
  }

  useEffect(() => {
    if (dataReceived) {
      fetchData()
      setPage(0)
    }
  }, [location.search])

  return (
    <div className="box">
      <div className="box__heading">Managed Meets</div>

      {/*{!dataReceived && <Loader />}*/}

      {dataReceived && !!managedMeets.list.length && (
        <Container>
          <div className="mb15">
            <div className="search-form search-form--compact">
              <div className="search-form__icon">
                <SearchOutlined />
              </div>
              <form onSubmit={onSearch}>
                <input
                  type="text"
                  id="search"
                  name="search"
                  placeholder="Search Meets"
                  className="search-form__field"
                  autoComplete="off"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </form>
            </div>
          </div>

          <Table
            columns={columns}
            data={managedMeets.list}
            fluid={columns.length <= 5}
            changingPage={changingPage}
            onDetailsOpen={(record) => onInfoOpen(record.id)}
            actions={(record) => [
              {
                component: () => (
                  <Tooltip title="Create a Meet copy" arrow key={key()}>
                    <FileCopyOutlinedIcon
                      onClick={() => onFormOpen(record.id, "copy")}
                    />
                  </Tooltip>
                ),
              },
              {
                component: () => (
                  <Tooltip title="Edit Meet" arrow key={key()}>
                    <EditOutlined onClick={() => onFormOpen(record.id)} />
                  </Tooltip>
                ),
              },
              {
                component: () => (
                  <Tooltip title="Delete Meet" arrow key={key()}>
                    <DeleteForeverOutlined
                      onClick={() => onDeletionOpen(record.id)}
                    />
                  </Tooltip>
                ),
              },
            ]}
          />
          <TablePagination
            count={100}
            page={page}
            onPageChange={(e, value) => setPage(value)}
            rowsPerPage={recordsPerPage}
            rowsPerPageOptions={recordsPerPageOptions}
            onRowsPerPageChange={(e) =>
              setRecordsPerPage(parseInt(e.target.value, 10))
            }
          />
        </Container>
      )}
      {dataReceived && !managedMeets.list.length && (
        <Stub text={"You don't have managed Meets yet"} />
      )}
    </div>
  )
}

const ManagedMeets = () => {
  const dispatch = useDispatch()

  const getRecords = async ({ name, offset, limit } = {}) => {
    await dispatch(managedMeetsList({ name, offset, limit }))
  }

  return (
    <MeetModalsProvider updateList={getRecords}>
      <MeetsTable getRecords={getRecords} />
    </MeetModalsProvider>
  )
}

export default ManagedMeets
